import { convertToInternationalNumber } from "./phoneUtils";

const internationalPhoneNumberRegEx = /^\+[1-9]{1}[0-9]{7,14}$/;

const validateInternationalPhoneNumber = (phoneNumber: string) => internationalPhoneNumberRegEx.test(phoneNumber.replaceAll(" ", ""));

export { validateInternationalPhoneNumber };
